import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Actions from 'App/components/Actions'
import MdAccessTime from 'react-icons/lib/md/access-time'
import moment from 'moment'
import withOrganization from 'App/Decorators/withOrganization'
import TagsFilter from '../../../components/fields/TagsFilter'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import MdArchive from 'react-icons/lib/md/archive'
import MdSend from 'react-icons/lib/md/send'
import Checkbox from '../../Sign/Prepare/Field/Menu/Checkbox'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import { gql } from 'react-apollo'
import SignersStatus from '../Common/SignersStatus'

@withOrganization
@withMutation(gql`
  mutation applySignatureFields(
    $documentId: String
    $signatureId: String
    $organizationId: String
  ) {
    applySignatureFields(
      documentId: $documentId
      signatureId: $signatureId
      organizationId: $organizationId
    ) {
      _id
    }
  }
`)

@withMessage
@withOrganization
@withRouter
export default class OwnPendingDocuments extends React.Component {

  allIds=[];

  static propTypes = {
    organization: PropTypes.object,
    router: PropTypes.object,
    applySignatureFields: PropTypes.func,
    showMessage: PropTypes.func
  }

  state = {
    massiveToSign: [],
    isSelectedAll: false,
    failed: []
  }

  addToAll(id) {
    this.allIds.push(id)
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  @autobind
  async applySignatures(signatureId) {
    if (global.selSignatureId !== '') {
      signatureId = global.selSignatureId
    }

    console.log('Trataré de firmar ', this.state.massiveToSign)
    this.setState({loading: true})
    let mensajes = []
    for (const [key, value] of Object.entries(this.state.massiveToSign)) {
      if (value) {
        console.log('Firmaré documento ' + key)
        try {

          await this.props.applySignatureFields(
            {
              documentId: key,
              signatureId: signatureId,
              organizationId: this.props.organization._id
            },
            {
              refetchQueries: [
                'myDocumentsToSign',
                'myFeaDocumentsToSign',
                'documentCount',
                'organizationDocCount'
              ]
            }
          )
          console.log('Documento ' + key + ' firmado')

        } catch (error) {
          let mensaje = error.message
          mensaje = mensaje.replace('GraphQL3 error: ', '')
          mensajes.push(mensaje)
          const failed = this.state.failed
          failed.push(error)
          this.setState({failed: failed})
        }
      }
    }
    this.setState({loading: false})
    // this.setState({loading: false, excel: null, files: null})
    if (this.state.failed && this.state.failed.length !== 0) {
      if (mensajes) {
        mensajes.forEach(mensaje => {
          this.props.showMessage(mensaje)
        })
      }
      this.props.showMessage(`Proceso finalizado con ${this.state.failed.length} fallidos`)

    } else {
      this.props.showMessage('Proceso finalizado con éxito')
    }
    this.refs.paginated.reload()
    this.setState({failed: []})
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: '',
          name: '_id',
          render: ({_id}) => <MdAccessTime size={20} />
        },
        {title: 'Nombre', name: 'name'}
      ]
    }
    return [
      {
        title: '',
        name: '_id',
        render: ({_id}) => <Checkbox value={ this.isToMassive(_id) } onChange={ (val) => this.addToMasiveSign(val, _id)} />
      },
      {
        title: '',
        name: 'documentStatus{status}',
        render: ({_id}) => <MdAccessTime onClick={this.addToAll(_id)} size={20} />
      },
      {
        title: 'Nombre',
        name: 'name',
        sort: 'DESC'
      },
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}',
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      },
      {
        title: 'Tags',
        name: 'tags',
        render: ({tags}) => tags? tags.join(" ") : "" ,
        defaultSort: 'DESC',
        sort: 'DESC'
      } /*
      {
        title: '',
        name: '',
        render: item => this.renderActions(item)
      } */
    ]
  }

  isToMassive(id) {
    if (this.state.massiveToSign[id]) { return true }
    return false
  }

  addToMasiveSign(value, id) {

    let newState = this.state.massiveToSign
    if (id in newState) { newState[id] = value } else { newState[id] = value }

    this.setState({massiveToSign: newState})
    console.log('massive: ', this.state.massiveToSign)
  }

  renderActions(item) {

    if (!item.documentOwner) {
      return (
        <div>
          <span>
            <Actions options={this.renderOptions(item)} />
          </span>
        </div>
      )
    }
  }

  renderAlert(item) {
    return (
      <div onClick={() => this.alert(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdSend size={20} style={{color: 'blue'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Recordar firma</div>
          </div>
        </span>
      </div>
    )
  }

  renderOptions(item) {
    return [this.renderAlert(item)]
  }

  renderArchive(item) {
    return (
      <div onClick={() => this.archiveDocument(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdArchive size={20} />
            </div>
            <div className="col-xs-12 col-sm-9">Archivar documento</div>
          </div>
        </span>
      </div>
    )
  }

  selectAll(valor) {
    console.log('own', this.allIds)
    console.log('Debo Seleccionar: ' + this.state.isSelectedAll)
    let newIsSelectedAll = !this.state.isSelectedAll

    let newState = this.state.massiveToSign
    this.allIds.forEach(id => {
      newState[id] = newIsSelectedAll
    })
    this.setState({massiveToSign: newState, isSelectedAll: newIsSelectedAll})
  }

  getCantidadSeleccionados() {
    if (!this.state.massiveToSign) { return 0 }
    let incluidos = 0
    for (const [key, value] of Object.entries(this.state.massiveToSign)) {
      console.log(key, value)
      if (value) { incluidos++ }
    }
    console.log(incluidos + ' incluidos')
    return incluidos
  }

  @autobind
  async seleccionarFirma() {
    if (this.getCantidadSeleccionados() < 1) {
      alert('Debe seleccionar al menos un documento')
      return
    }
    const signatureId = await global.getSelSignature()
    console.log('Seleccionada ' + signatureId)
    if (signatureId) {
      this.applySignatures(signatureId)
    }
  }

  render() {
    return (

      <div className={styles.container}>
        <div className="section">

          <div className="table">
            <Paginated
              loadingComponent={Loading}
              headRightComponent={TagsFilter}
              queryName="ownPendingDocuments"
              fields={this.getFields()}
              defaultLimit={25}
              params="$filter: String $organization: String"
              ref="paginated"
              organization={this.props.organization._id}
              onPress={this.onSelect}
            />
          </div>
        </div>
        <div className={styles.container}>
          <Checkbox visilbe={this.allIds.length > 0} value={this.state.isSelectedAll} label="Seleccionar Todos" onChange={ (val) => this.selectAll(val) } />
          <Button loading={this.state.loading} onClick={() => this.seleccionarFirma()}>Firmar documentos seleccionados</Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/OwnPendingDocuments/index.js